import * as ACTION from '@Bootstraps/bootstrapActions';
import * as IMG from '@Utils/Images';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Component() {
  const [cartData, setCartDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cart, clothesInquiryResponse } = useSelector(state => state);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location?.search === "?cart") {
      dispatch(ACTION.clothesInquiry());
    };
  }, [dispatch, location?.search]);

  useEffect(() => {
    if (clothesInquiryResponse && clothesInquiryResponse.data) {
      setCartDatas(clothesInquiryResponse.data?.filter(cloth => cart.some(data => data?._id === cloth?._id)));
    };
  }, [dispatch, cart, clothesInquiryResponse]);

  useEffect(() => {
    if (cartData.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [cartData]);

  return (
    <>
      {!loading || cartData.length > 0 ? (
        cartData?.map((data) => (
          <div
            key={data?._id}
            className="cart row align-items-stretch justify-content-between bg-white border-primary2 rounded-4 m-0 mb-4 overflow-hidden"
          >
            <div className="col-lg-10 row align-items-center p-4 m-0">
              <div className="col-lg-5 p-0">
                <div
                  className="thumbnail border-primary2 rounded-4"
                  style={{ backgroundImage: `url(${data?.thumbnail})` }}
                />
              </div>
              <div className="col-lg-7 p-0 ps-lg-4">
                <h3 className="fw-bold mt-4 mt-lg-0">{data?.name}</h3>
                <div className="d-flex pt-1 mt-2 mb-4">
                  <h6 className="d-inline-block small bg-primary2 fw-semibold text-white rounded cursor-pointer py-2 px-3 m-0">
                    {data?.type?.toUpperCase()}
                  </h6>
                  <h6 className="d-inline-block small bg-primary2 fw-semibold text-white rounded cursor-pointer py-2 px-3 m-0 ms-2">
                    {data?.category?.toUpperCase()}
                  </h6>
                </div>
                <h2 className="fw-bold m-0 mb-4">
                  Rp.{' '}
                  {`${(
                    data?.price *
                    cart.filter((item) => item._id === data?._id)[0]?.value
                  ).toLocaleString('id-ID')},00`}
                </h2>
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-light fw-bold rounded-circle px-2"
                    style={{ padding: '2px' }}
                    onClick={() => {
                      dispatch(
                        ACTION.setCart(
                          cart.map((el) =>
                            el?._id === data?._id
                              ? {
                                  ...el,
                                  value: el?.value > 1 ? el?.value - 1 : 1,
                                }
                              : el
                          )
                        )
                      );
                    }}
                  >
                    -
                  </button>
                  <h6 className="bg-light-primary border-primary2 normal rounded cursor-pointer py-1 px-2 m-0 mx-3">
                    {cart.filter((el) => el?._id === data?._id)[0]?.value}
                  </h6>
                  <button
                    className="btn btn-primary2 fw-bold rounded-circle px-2"
                    style={{ padding: '2px' }}
                    onClick={() => {
                      dispatch(
                        ACTION.setCart(
                          cart.map((el) =>
                            el?._id === data?._id
                              ? { ...el, value: el?.value + 1 }
                              : el
                          )
                        )
                      );
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <div
              className="col-lg-1 delete d-flex align-items-center justify-content-center btn btn-dark text-primary2 rounded-0 cursor-pointer p-0 mt-2 mt-lg-0"
              onClick={() =>
                dispatch(
                  ACTION.setCart(cart.filter((item) => item._id !== data?._id))
                )
              }
            >
              <h5 className="m-0">
                <i className="fas fa-trash"></i>
              </h5>
            </div>
          </div>
        ))
      ) : (
        <img src={IMG.EMPTY_CART} alt="empty" className="cart-image d-block mx-auto" />
      )}
    </>
  );
}